import React, { useState, useMemo } from "react";
import Chevron from "../../../../assets/customSVG/ChevronCrm";
import { getRandomColorsBassedOnLetters } from "../../../../helper/colors";

export const TeamMembersFilters = ({ activeFilter, setActiveFilter, teamMembers }) => {
  const [isFilterDropdownOpen, setIsFilterDropdownOpen] = useState(true);

  // Define color options
  const avatarColors = [
    { bg: "bg-purple-200", text: "text-purple-800" },
    { bg: "bg-green-200", text: "text-green-800" },
    { bg: "bg-yellow-200", text: "text-yellow-800" },
    { bg: "bg-pink-200", text: "text-pink-800" },
    { bg: "bg-blue-200", text: "text-blue-800" },
    { bg: "bg-red-200", text: "text-red-800" },
    { bg: "bg-indigo-200", text: "text-indigo-800" },
    { bg: "bg-teal-200", text: "text-teal-800" },
    { bg: "bg-orange-200", text: "text-orange-800" },
    { bg: "bg-amber-200", text: "text-amber-800" },
    { bg: "bg-lime-200", text: "text-lime-800" },
    { bg: "bg-rose-200", text: "text-rose-800" },
    { bg: "bg-cyan-200", text: "text-cyan-800" },
    { bg: "bg-fuchsia-200", text: "text-fuchsia-800" },
    { bg: "bg-violet-200", text: "text-violet-800" },
    { bg: "bg-sky-200", text: "text-sky-800" },
  ];
  
  // Assign random color to each member once
  const coloredTeamMembers = useMemo(() => {
    return teamMembers.map((member) => {
      const color = avatarColors[Math.floor(Math.random() * avatarColors.length)];
      return { ...member, color };
    });
  }, [teamMembers]);


  return (
    <div className="mb-2">
      <div
        className="flex justify-between items-center px-4 py-3 cursor-pointer"
        onClick={() => setIsFilterDropdownOpen(!isFilterDropdownOpen)}
      >
        {/* <p className="text-gray-800 font-semibold font-medium text-base">Team Members</p> */}
        <p className="font14px-600 text-gray-800 mt-2 ">Team Members</p>

        <span
          className={`transition-transform duration-300 ${
            isFilterDropdownOpen ? "transform rotate-180" : ""
          }`}
        >
          <Chevron />
        </span>
      </div>

      <div
        className={`transition-all duration-200 overflow-hidden ${
          isFilterDropdownOpen ? "max-h-96" : "max-h-0"
        }`}
      >
        {coloredTeamMembers.map((member) => (
          <div
            key={member.id}
            className={`flex items-center gap-3 mx-4 px-3 py-2 rounded-md cursor-pointer ${
              activeFilter.email === member.email ? "sidebar-sub-header-active" : "sidebar-sub-header hover:bg-slate-100"
            }`}
            onClick={() => {
              setActiveFilter(member)
            }}
          >

            <span
                      className="w-7 h-7 rounded-full border-[2px] border-white text-[0.65rem] font-[600]  flex items-center justify-center"
                      style={{
                        color: "white",
                        backgroundColor: getRandomColorsBassedOnLetters(
                          member?.user_name?.slice(0, 1).toUpperCase(),
                          1.5
                        ).backgroundColor,
                      }}
                    >
                      {member?.user_name?.slice(0, 1).toUpperCase()}
                    </span>
            <p
              className={`${
                activeFilter.email === member.email ? "text-green-700 font14px-500" : "font14px-400 text-gray-700"}`}
            >
              {member.user_name.charAt(0).toUpperCase() + member.user_name.slice(1)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};